import React, { useCallback, useState } from "react";
import { CurrentPdfProvider } from "@/contexts/setPdfContext";
import { ContextSidebar } from "@/components/feature/layout/left-sidebar/contextSidebar";
import { motion } from "framer-motion";
import { useParams } from "react-router";
import { useCurrentPdf } from "@/modules/chat/hooks/useCurrentPdf";

interface Props {
  children: React.ReactNode;
}

export const LayoutWrapper: React.FC<Props> = ({ children }) => {
  const { fseId = "" } = useParams<{ fseId: string }>();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const { handleFileSelect } = useCurrentPdf();
  const toggleSidebarVisibility = useCallback(() => {
    setIsSidebarVisible(prev => !prev);
  }, []);

  return (
    <div className="-mx-4 -my-8 flex h-screen overflow-hidden bg-[#f7f3ee] sm:-mx-6 lg:-mx-8">
      <ContextSidebar
        systemId={fseId}
        onFileSelect={handleFileSelect}
        isVisible={isSidebarVisible}
        onToggleVisibility={toggleSidebarVisibility}
        showFolders={true}
        showToggleAll={true}
      />

      <main className="flex flex-grow overflow-hidden">
        <motion.div
          className="flex flex-grow overflow-hidden"
          animate={{ width: "60%" }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
};

export const ReportsLayoutContent: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <CurrentPdfProvider>
    <LayoutWrapper>{children}</LayoutWrapper>
  </CurrentPdfProvider>
);
